module.exports = __webpack_public_path__ + "static/media/prohibition.4f99d897.png";